import CreateInvestmentError from './CreateInvestmentError';
class CouponAlreadyUsed extends CreateInvestmentError {
    constructor(options) {
        super('Coupon was used in another investment', options);
    }
}
export default CouponAlreadyUsed;
